import React, { Component } from 'react';
import { 
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { faLightbulb } from '@fortawesome/free-regular-svg-icons';

class NotesModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false 
    };
  }

  toggle() {
    const { showModal } = this.state;
    this.setState({ showModal: !showModal }); 
  }

  render() {
    const { showModal } = this.state;
    const { title, body } = this.props;

    return (
      <div>
        <Button 
          style={{borderRadius: "50%", width: "3rem", height: "3rem"}} 
          color="secondary" 
          onClick={this.toggle.bind(this)}>
          <FontAwesomeIcon icon={faLightbulb} size="lg" className="text-white" />
        </Button>
        <Modal isOpen={showModal} toggle={this.toggle.bind(this)}>
          <ModalHeader toggle={this.toggle.bind(this)}>
            <span className="fa-layers fa-fw mr-3">
              <FontAwesomeIcon icon={faCircle} transform="grow-15" className="text-secondary" />
              <FontAwesomeIcon icon={faLightbulb} className="text-white" />
            </span>
            { title ? title : "Insight" }
          </ModalHeader>
          <ModalBody>{body}</ModalBody>
          <ModalFooter className="bg-light">
            <Button color="primary" onClick={this.toggle.bind(this)}>Close</Button>
          </ModalFooter>
        </Modal>
      </div>
    ); 
  }
}

export default NotesModal;
